/* istanbul ignore file */

import { css } from 'styled-components';

import { visuallyHidden } from './hiders';

export const ICON_BUTTON_TEXT_CLASS = 'icon_button__text';

export const iconButton = css`
  padding: 0;
  border: none;
  background: none;
  cursor: pointer;

  .${ICON_BUTTON_TEXT_CLASS} {
    ${visuallyHidden}
  }
`;
